import { render, staticRenderFns } from "./DataLoading.vue?vue&type=template&id=78983368&scoped=true"
import script from "./DataLoading.ts?vue&type=script&lang=ts&external"
export * from "./DataLoading.ts?vue&type=script&lang=ts&external"
import style0 from "./DataLoading.vue?vue&type=style&index=0&id=78983368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78983368",
  null
  
)

export default component.exports